// extracted by mini-css-extract-plugin
export default {"table":"ReactMarkdown_table__Nf1dp"};